export const MIXPANEL_PAGE_NAME = 'Homepage';
export const BIGQUERY_PAGE_NAME = 'homepage';

export const BIGQUERY_BRAND_PAGE_NAME = 'LOHP brand';
export const BIGQUERY_BRAND_PAGE_NAME_V16 = 'LOHP brand v16';
